import { LOCATION_CHANGE } from 'connected-react-router';
import { match } from '../../../../shared/utils/match';
import { createMiddleware } from '../../../../shared/redux';
import {
    ACCEPT_FORM,
    acceptForm,
    COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED,
    rejectUpdateSignUpData,
    requestCompanySignUpDataUpdate,
    requestUserProfileSignUpDataUpdate,
    SIGN_UP_DATA_UPDATE_SUBMITTED,
    USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED,
} from './update-sign-up-data.state';
import { validateCompany, validateUserProfile } from './update-sign-up-data.validation';
import {
    isCompanySignUpDataComplete,
    isUserProfileSignUpDataComplete,
    setIsCompanySignUpDataComplete,
    setIsUserProfileSignUpDataComplete,
} from '../check-sign-up-data.state';
import { acceptSignIn } from '../../sign-in/sign-in.state';
import Routes from '../../../router/routes.constants';
import { ROUTES } from '../../auth.constants';
import { redirectToSplashScreen } from '../../splash-screen/splash-screen-state';

export const updateSignUpDataMiddleware = createMiddleware({
    [LOCATION_CHANGE]: match((_, action) => action.payload.location.pathname, {
        [ROUTES.UPDATE_SIGN_UP_DATA]: (state, action) => {
            if (action.payload.action === 'POP') {
                return redirectToSplashScreen();
            }
            return [];
        },
    }),
    [SIGN_UP_DATA_UPDATE_SUBMITTED]: async (state, action) => {
        const { userProfile, team } = action.payload;
        const isUserProfileComplete = isUserProfileSignUpDataComplete(state);
        const isCompanyComplete = isCompanySignUpDataComplete(state);
        const actions = [];

        try {
            if (!isUserProfileComplete) {
                await validateUserProfile(userProfile);
                actions.push(requestUserProfileSignUpDataUpdate({ ...userProfile }));
            }

            if (!isCompanyComplete) {
                await validateCompany(team);
                actions.push(requestCompanySignUpDataUpdate({ ...team }));
            }

            return actions;
        } catch (error) {
            return rejectUpdateSignUpData(error);
        }
    },
    [USER_PROFILE_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED]: () => [
        setIsUserProfileSignUpDataComplete({ isComplete: true }),
        acceptForm(),
    ],
    [COMPANY_SIGN_UP_DATA_UPDATE_REQUEST_SUCCEEDED]: () => [
        setIsCompanySignUpDataComplete({ isComplete: true }),
        acceptForm(),
    ],
    [ACCEPT_FORM]: (state) => {
        const isUserProfileComplete = isUserProfileSignUpDataComplete(state);
        const isCompanyComplete = isCompanySignUpDataComplete(state);

        if (isUserProfileComplete && isCompanyComplete) {
            return acceptSignIn({ landingRoute: `${Routes.INTEGRATIONS}#onboarding` });
        }
        return [];
    },
});
